import React from "react";
import { WriteIcon } from "modules/icons";
import useStyles from "./styles";

type EditButtonProps = {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium" | "big";
  title?: string;
};

export const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  size = "medium",
  title,
}) => {
  const { classes, cx } = useStyles();

  const sizeClass =
    size === "small"
      ? classes.buttonSmall
      : size === "big"
      ? classes.buttonBig
      : classes.buttonMedium;

  return (
    <button
      title={title}
      className={cx(classes.editButton, classes.button, sizeClass)}
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <WriteIcon />
    </button>
  );
};
